<template>
  <!--分页组件-->
  <div style="text-align: right;padding: 10px 0">
    <el-pagination :small="small" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="this.pageIndex"
                   :page-size="this.pageSize" :pager-count="5"
                   :layout="layout"
                   :page-sizes="pageSizes"
                   :total="this.totalRecords">
    </el-pagination>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  props: {
    totalRecords: {
      type: Number,
      default: 0
    },
    pageIndex: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    layout: {
      type: String,
      default: 'total,sizes, prev, pager, next, jumper'
    },
    small: {
      type: Boolean,
      default: false
    },
    pageSizes: {
      type: Array,
      default: () => {
        return [10, 20, 30, 40, 50, 100]
      }
    }
  },
  methods: {
    handleSizeChange (val) {
      // console.log(`每页 ${val} 条`)
      this.$emit('changePageSize', val)
    },
    handleCurrentChange (val) {
      // console.log(`当前页: ${val}`)
      this.$emit('changePageNumber', val)
    }
  }
}
</script>

<style scoped>
</style>
